import { render } from "./MiamdealDashboard.vue?vue&type=template&id=235885e4&scoped=true"
import script from "./MiamdealDashboard.vue?vue&type=script&lang=js"
export * from "./MiamdealDashboard.vue?vue&type=script&lang=js"

import "./MiamdealDashboard.vue?vue&type=style&index=0&id=235885e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235885e4"]])

export default __exports__